<template>
  <div class="container">
    <div class="row justify-content-center">

      <GuideCard
          v-if="AI_GENERATION_AND_VISUALIZATION"
          imageSrc="https://silkplm.com/wp-content/uploads/2025/02/Inspirations-quick-guide.png"
          imageAlt="AI Creations"
          :titleDefault="$tr('getStarted.title.generate.ai.inspirations', 'Generate AI Inspirations')"
          :bodyDefault="$tr('getStarted.body.generate.ai.inspirations','See how to generate design inspirations with our AI tools and where to store them.')"
          :onPrimaryClick="startAiTour"
          manualLink=""
          videoLink="https://youtu.be/aWWu3GOvmfk"
          imageLink="https://youtu.be/aWWu3GOvmfk"
          :videos='inspirationsVideosGuides'
      />

      <GuideCard
          v-if="AUTOMATE_LABELING"
          imageSrc="https://silkplm.com/wp-content/uploads/2025/02/Branding-quick-quide.png"
          imageAlt="Branding and Care Labels"
          :titleDefault="$tr('getStarted.title.branding.and.care.labels', 'Branding and Care Labels')"
          :bodyDefault="$tr('getStarted.body.branding.and.care.labels','Assign label data to products, modify it, and generate it automatically from the system.')"
          :onPrimaryClick="startLabelTour"
          manualLink="https://silkplm.com/wp-content/uploads/2025/02/Branding-guide.pdf"
          videoLink="https://youtu.be/r_7DI86TxPU"
          imageLink="https://youtu.be/r_7DI86TxPU"
          :videos='brandingVideosGuides'
      />

      <GuideCard
          v-if="PREPARE_PRODUCT_FOR_PRODUCTION"
          imageSrc="https://silkplm.com/wp-content/uploads/2025/02/Inquiry-1.png"
          imageAlt="Inquiry for Suppliers"
          :titleDefault="$tr('getStarted.title.inquiry.for.suppliers', 'Project Specification for Contractors')"
          :bodyDefault="$tr('getStarted.body.inquiry.for.suppliers','See how easy it is to automatically generate PDFs and send them to contractors.')"
          :onPrimaryClick="startInquiryTour"
          manualLink=""
          videoLink="https://www.youtube.com/watch?v=WyG-96yETIk"
          imageLink="https://www.youtube.com/watch?v=WyG-96yETIk"
          :videos='inquiryVideosGuides'
      />

    </div>
  </div>
</template>

<script>
import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";
import GuideCard from "@/components/dashboard/GuideCard.vue";
import { inspirationsVideosGuides } from "@/components/dashboard/guidesVideoObjects/InspirationsVideos";
import {brandingVideosGuides} from "@/components/dashboard/guidesVideoObjects/BrandingVideos";
import {inquiryVideosGuides} from "@/components/dashboard/guidesVideoObjects/InquiryVideos";

export default {
  name: "GetStartedWelcomeScreen",
  components: {
    GuideCard
  },
  methods: {
    startAiTour() {
      window['Guides'].addInspiration();
    },
    startLabelTour() {
      window['Guides'].assignLabel();
    },
    startInquiryTour() {
      window['Guides'].getInquiry();
    },
  },
  data: () => ({
    AI_GENERATION_AND_VISUALIZATION: SessionManager.hasFlag(FeatureFlag.GET_STARTED_WELCOME_GUIDS),
    PREPARE_PRODUCT_FOR_PRODUCTION: SessionManager.hasFlag(FeatureFlag.GET_STARTED_WELCOME_GUIDS),
    AUTOMATE_LABELING: SessionManager.hasFlag(FeatureFlag.GET_STARTED_WELCOME_GUIDS),
    inspirationsVideosGuides: inspirationsVideosGuides(),
    brandingVideosGuides: brandingVideosGuides(),
    inquiryVideosGuides: inquiryVideosGuides()
  })
};
</script>
